/**
 * Reveals the Instagram feed tiles one after another as the grid scrolls
 * into view, replacing the per-tile scroll trigger the legacy Webflow export
 * drove through its IX2 interactions data (data-w-id, not present in this
 * theme's exported CSS/Liquid, so there was nothing to port forward — see
 * CLAUDE.md). The stagger itself lives in CSS as per-tile transition-delay;
 * this only has to flip one class once the grid is in view.
 */
class InstagramFeedGrid extends HTMLElement {
  connectedCallback() {
    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !('IntersectionObserver' in window)
    ) {
      this.classList.add('is-visible');
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.classList.add('is-visible');
            obs.disconnect();
          }
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(this);
  }
}

if (!customElements.get('instagram-feed-grid')) {
  customElements.define('instagram-feed-grid', InstagramFeedGrid);
}
